import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class AboutV5 extends Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';

        return (
            <div className="">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 ">
                            <div className="">
                                 <img 
                                    src="https://keurgui-images.ams3.digitaloceanspaces.com/kr.png" 
                                    alt="Keurgui" 
                                    style={{ width: '100%', height: 'auto' }}
                                />

                            </div>
                        </div>
                        <div className="col-lg-7 align-self-center">
                            <div className="about-us-info-wrap justify-text">
                                <div className="">
                                    <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Bienvenue sur Keurgui</h6>
                                    <h1 className="section-title">Une révolution dans le secteur locatif au Sénégal<span>.</span></h1>
                                    <p style={{ textAlign: 'justify' }}>
                                        Cher(e) Utilisateur(trice),
                                    </p>
                                    <p style={{ textAlign: 'justify' }}>
                                        C’est avec un immense plaisir que, depuis la plateforme Keurgui, nous vous présentons notre initiative dédiée à la transformation du secteur locatif au Sénégal. En tant qu'équipe, nous avons l’honneur de vous dévoiler ce site, fruit d’une vision commune et d’une collaboration étroite avec des experts reconnus du secteur immobilier, pour répondre efficacement aux besoins des locataires et des propriétaires.
                                    </p>
                                </div>
                                <div className="">
                                    <p style={{ textAlign: 'justify' }}>
                                        Keurgui ne se limite pas à une simple plateforme de gestion locative. Aux côtés de professionnels chevronnés de l’immobilier, nous avons fixé des objectifs stratégiques qui vont bien au-delà, en nous concentrant sur plusieurs axes essentiels :
                                    </p>
                                    <ul style={{ textAlign: 'justify' }}>
                                        <li><strong>Accessibilité Financière :</strong> Des solutions de paiement flexibles et des options de financement adaptées pour faciliter l’accès au logement.</li>
                                        <li><strong>Transparence :</strong> Visibilité totale sur les transactions, contrats et conditions de location, favorisant la confiance entre locataires et propriétaires.</li>
                                        <li><strong>Sécurité :</strong> Technologies de pointe pour la protection des données et transactions sécurisées.</li>
                                        <li><strong>Innovation :</strong> Intégration des dernières technologies : outils de recherche avancés, visites virtuelles, systèmes de gestion automatisés.</li>
                                    </ul>
                                    <p style={{ textAlign: 'justify' }}>
                                        Grâce à Keurgui et à l’expertise des professionnels qui nous accompagnent, nous offrons une expérience de location améliorée et inclusive, où chaque utilisateur peut trouver la propriété qui répond parfaitement à ses besoins dans un environnement sûr et transparent.
                                    </p>
                                    <p style={{ textAlign: 'justify' }}>
                                        Je vous invite à explorer Keurgui et à découvrir comment notre plateforme, enrichie par le savoir-faire de spécialistes de l’immobilier, peut transformer votre recherche de logement ou la gestion de vos biens.
                                    </p>
                                    <p style={{ textAlign: 'justify' }}>
                                        <strong>L'équipe - Keurgui</strong>
                                    </p>
                                </div>
                                <div className="btn-wrapper animated">
                                    <Link to="/contact" className="theme-btn-1 btn btn-effect-1 text-uppercase">Nous contacter</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutV5;